<template>
	<div class="tab-body">
		<div class="search">
			<el-form ref="form" :model="searchParams" label-width="80px">
				<el-row v-if="!prodId">
					<el-col :span="4">
						<el-form-item label="产品">
							<el-select v-model="searchParams.proId" clearable @change="chgPro"
								placeholder="请选择">
								<el-option v-for="item in productList" :key="item.id" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item label="附件名称">
							<el-autocomplete class="inline-input" v-model="searchParams.name"
								:fetch-suggestions="listName" placeholder="可搜索"
								:trigger-on-focus="false"></el-autocomplete>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item label="附件类型">
							<select-option-dictionary v-model="searchParams.type"
								dkey="attach-type"></select-option-dictionary>
						</el-form-item>
					</el-col>
					<div class="search-btn">
						<el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
						<el-button @click="clearSearchVal">清空</el-button>
					</div>
				</el-row>
				<el-row v-else>
					<el-col :span="10">
						<el-form-item label="当前产品">
							<el-input :value="prodNm" readonly></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<div class="operator">
			<el-button type="primary" icon="el-icon-plus" @click="toSave()">添加附件</el-button>
			<el-button v-if="prodId" type="success" icon="el-icon-back" @click="retProd()">返回产品列表</el-button>
			<el-button type="danger" icon="el-icon-delete" @click="batchRemove()">批量删除</el-button>
		</div>
		<div class="dataTable autoFlex" v-if="listData">
			<el-table class="table" :data="listData.records" stripe border height="auto"
				@selection-change="selectionChange" v-loading="listLoading">
				<el-table-column type="selection" width="55" fixed="left"></el-table-column>
				<el-table-column prop="name" label="附件名称"></el-table-column>
				<el-table-column prop="type" label="附件类型"></el-table-column>
				<el-table-column prop="path" label="附件预览">
					<template slot-scope="scope">
						<el-tooltip class="item" effect="dark" content="点击预览PDF文件" placement="top">
							<el-link type="danger" @click="preview(scope.$index, scope.row)">预览{{
				scope.row.name
			}}PDF文件</el-link>
						</el-tooltip>
					</template>
				</el-table-column>
				<el-table-column label="操作" fixed="right" width="200px">
					<template slot-scope="scope">
						<div class="dataTable-operator">
							<el-button size="mini" icon="el-icon-download" type="primary"
								@click="download(scope.$index, scope.row)">下载附件</el-button>
							<el-button size="mini" icon="el-icon-delete" type="danger"
								@click="remove(scope.$index, scope.row)">删除</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<div class="pageBar">
				<el-pagination @size-change="sizeChange" @current-change="currentChange" :total="listData.total"
					:page-size="page.size" :current-page="page.current" :layout="this.$constant.page.layout"
					:page-sizes="this.$constant.page.pageSizes"></el-pagination>
			</div>
			<el-dialog title="预览PDF" :visible.sync="dialogTableVisible">
				<PDF v-for="i in numPages" :key="i" :page="i" :src="preSrc" ref="myPdfComponent"></PDF>
			</el-dialog>
		</div>
		<edit ref="edit"></edit>
	</div>
</template>
<script>
import edit from './edit.vue';
import api from '@/api/attachment/attachment/attachment.js';
import selectOptionDictionary from '@/components/biz/selectOptionDictionary/selectOptionDictionary.vue';
import productApi from "@/api/product/product/product.js";
import PDF from 'vue-pdf';
// 解决部分文字不显示的问题
import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js'
export default {
	name: 'attachment',
	components: {
		edit,
		selectOptionDictionary,
		PDF
	},
	data() {
		return {
			searchParams: {},
			isShowMoreSearch: false,
			listLoading: false,
			listData: [],
			selected: [],
			prodId: '',
			prodNm: '',
			preData: '', //预览PDF数据
			preSrc: '',
			numPages: 0,
			dialogTableVisible: false, //对话框显示参数
			productList: [], //装载产品的数据
			page: new this.$constant.pageObj(),
		};
	},
	methods: {
		chgPro() {

		},
		//获取数据
		list() {
			//拿到productId参数，用于判断是附件管理跳转过来的还是菜单栏来的
			if (this.$route.query.productId) {
				this.prodId = this.$route.query.productId;
				this.prodNm = this.$route.query.prodNm;
				this.searchParams.productId = this.prodId;
			}else{
				this.prodId = this.$caches.pid.get();
			}
			this.listLoading = true;

			//获取产品数据并存入productData
			this.productList = this.$caches.products.get();
			if (!this.productList) {
				//获取产品数据并存入productData
				productApi.list4Select({}, response => {
					this.productList = response.data;
					this.searchParams.name = this.productList[0].name;
					this.$caches.products.set(this.productList);
				})
			}


			let params = this.$utils.merger(this.searchParams, this.page);
			api.list(params, response => {
				this.listData = response.data;
				this.listLoading = false;
			})
		},
		listName(queryName, showResult) {
			//发送请求模糊查询
			api.listName({ name: queryName }, response => {
				showResult(response.data);
			});
		},
		//返回产品列表
		retProd() {
			this.$router.replace('/product/product');
		},
		//下载
		download(index, row) {
			api.download({ id: row.id, method: "1" }, row.name);
		},
		//预览pdf文件
		preview(index, row) {
			console.log('index ', row);
			api.preview({ id: row.id, method: "0" }, res => {
				console.log('=================================================================');
				console.log('msg ', res.msg);
				//获取预览PDF数据
				this.preData = "data:application/pdf;base64," + res.msg;
				this.preSrc = PDF.createLoadingTask({ url: this.preData, CMapReaderFactory });
				this.preSrc.promise.then(pdf => {
					this.numPages = pdf.numPages;
				});
				this.dialogTableVisible = true;
			});
		},
		//去添加
		toSave() {
			this.$refs.edit.open({}, '添加', false, this.prodId);
		},
		//去编辑
		toUpdate(index, row) {
			let editParameter = {
				id: row.id
			};
			this.$refs.edit.open(editParameter, '编辑');
		},
		//去详情
		toDetail(index, row) {
			let detailParameter = {
				id: row.id
			};
			this.$refs.edit.open(detailParameter, '详情', true);
		},
		//删除
		remove(index, row) {
			let parameter = {
				ids: row.id
			}
			this.$utils.confirm.warning('提示', '确定删除吗？', () => {
				api.remove(
					parameter,
					response => {
						this.$utils.msg.success(response.msg);
						this.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
			});
		},
		//批量删除
		batchRemove() {
			if (!this.selected || this.selected.length == 0) {
				this.$utils.msg.info('请选择至少一行');
				return;
			}
			let parameter = {
				ids: this.selected
			};
			this.$utils.confirm.warning('提示', '确定删除吗？', () => {
				api.remove({
					ids: this.selected
				},
					response => {
						this.$utils.msg.success(response.msg);
						this.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
			});
		},
		//改变选择项
		selectionChange(val) {
			//清空
			this.selected = [];
			for (let item of val) {
				this.selected.push(item.id);
			}
		},
		//改变每页显示数量
		sizeChange(val) {
			this.page.size = val;
			this.list();
		},
		//改变现在的页码
		currentChange(val) {
			this.page.current = val;
			this.list();
		},

		//搜索
		search() {
			this.list();
		},
		//清空搜索框
		clearSearchVal() {
			this.searchParams = {};
		}
	},
	mounted() {
		this.list();
	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
</style>
